module.exports = __webpack_public_path__ + "img/diashow (7).d978aa0.jpg";